import { Button, Segmented, Space } from 'antd';
import { MailOutlined } from '@ant-design/icons';

type HomeHeaderProps = {
  activeTab: 'home' | 'dj-depot';
  onTabChange: (tab: 'home' | 'dj-depot') => void;
};

const HomeHeader = ({ activeTab, onTabChange }: HomeHeaderProps) => (
  <>
    <div className="brand">Shrimp Domain</div>
    <Space size="large" className="header-links">
      <Segmented
        value={activeTab}
        onChange={(value) => onTabChange(value as 'home' | 'dj-depot')}
        options={[
          { label: 'Home', value: 'home' },
          { label: 'DJ Depot', value: 'dj-depot' },
        ]}
      />
      {activeTab === 'home' ? (
        <>
          <Button type="link" href="#hero">
            About
          </Button>
          <Button type="link" href="#video">
            Video Intro
          </Button>
          <Button type="link" href="#projects">
            Projects
          </Button>
        </>
      ) : (
        <>
          <Button type="link" href="#dj-directory">
            DJs
          </Button>
          <Button type="link" href="#dj-directory">
            Mixes
          </Button>
        </>
      )}
      <Button
        type="primary"
        ghost
        href="mailto:marcoscortorreal@gmail.com"
        icon={<MailOutlined />}
      >
        Contact
      </Button>
    </Space>
  </>
);

export default HomeHeader;
